import { Group } from './bar.model';

export const barData: Group[] = [
  {
    id: 'FD',
    name: 'FD',
    route: '',
    routeName: 'FD',
    items: [
      {
        id: 'FD-KTL',
        name: 'KTL',
        route: '',
        disabled: true,
        expand: true,
        childs: [
          {
            id: 'FD-KTL-INPUT',
            name: 'Input',
            routeName: 'Input',
            route: '/FD/KTL/Input/ProcessEngineer/Flaring',
            disabled: true,
            expand: true,
            schilds: [
              {
                id: 'FD-KTL-INPUT-PROCESSENGINEER',
                name: 'Process Engineer',
                route: '',
                disabled: true,
                expand: true,
                tchilds: [
                  {
                    id: 'FD-KTL-INPUT-PROCESSENGINEER-FLARING',
                    name: 'Flaring',
                    route: '/FD/KTL/Input/ProcessEngineer/Flaring',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FD-KTL-INPUT-PROCESSENGINEER-MW',
                    name: 'MW',
                    route: '/FD/KTL/Input/ProcessEngineer/MW',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FD-KTL-INPUT-PROCESSENGINEER-LEAKAGE',
                    name: 'Leakage',
                    route: '/FD/KTL/Input/ProcessEngineer/Leakages',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FD-KTL-INPUT-PROCESSENGINEER-CONSTANTS',
                    name: 'Constants',
                    route: '/FD/KTL/Input/ProcessEngineer/Constants',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FD-KTL-INPUT-PROCESSENGINEER-PERMITS',
                    name: 'Permits',
                    route: '/FD/KTL/Input/ProcessEngineer/TargetPermit',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FD-KTL-INPUT-PROCESSENGINEER-INPUT-HISTORY',
                    name: 'Input History',
                    route: '/FD/KTL/Input/ProcessEngineer/InputHistory',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
              {
                id: 'FD-KTL-INPUT-OPERATOR',
                name: 'Operator',
                route: '',
                disabled: false,
                expand: true,
                tchilds: [
                  {
                    id: 'FD-KTL-INPUT-OPERATOR-FLARING',
                    name: 'Flaring ',
                    route: '/FD/KTL/Input/Operator',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
              {
                id: 'FD-KTL-INPUT-DIAGNOSTICIAN',
                name: 'Diagnostician',
                route: '/FD/KTL/Input/Diagnostician',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: 'FD-KTL-INPUT-DIAGNOSTICIAN-LEAKAGE',
                    name: 'Leakage ',
                    route: '/FD/KTL/Input/Diagnostician/Leakage',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FD-KTL-INPUT-DIAGNOSTICIAN-FLARESWITCHER',
                    name: 'Flare Switcher',
                    route: '/FD/KTL/Input/Diagnostician/FlareSwitcher',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FD-KTL-DAILY-REPORT',
            name: 'Daily Report',
            route: '/FD/KTL/DailyReport',
            routeName: 'DailyReport',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: 'FD-KTL-DAILY-REPORT-REPORTS',
                name: 'Daily Reports',
                route: '/FD/KTL/DailyReport',
                disabled: true,
                expand: true,
                tchilds: [
                  {
                    id: 'FD-KTL-DAILY-REPORT-REPORTS-DAILY-REPORT',
                    name: 'Daily Report',
                    route: '/FD/KTL/DailyReport',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FD-KTL-DAILY-REPORT-REPORTS-F-205-KTL2',
                    name: 'KTL-2 F-205',
                    route: 'FD/KTL/F205/KTL2',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FD-KTL-DAILY-REPORT-REPORTS-F-205-KTL23',
                    name: 'KTL-2.3 F-205',
                    route: 'FD/KTL/F205/KTL23',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FD-KTL-MONTHLY-REPORT',
            name: 'Monthly Report',
            route: '/FD/KTL/MonthlyReport',
            routeName: 'MonthlyReport',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: 'FD-KTL-MONTHLY-REPORT',
                name: '',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    disabled: false,
                    expand: false,
                    route: '',
                  },
                ],
              },
            ],
          },
          {
            id: 'FD-KTL-CHEMICAL-COMPOSITION',
            name: 'Chemical Composition',
            route: '/FD/KTL/cc',
            routeName: 'cc',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: 'FD-KTL-CHEMICAL-COMPOSITION',
                name: '',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FD-KTL-SCHEMA',
            name: 'Schema',
            route: '/FD/KTL/Schema',
            routeName: 'Schema',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: 'FD-KTL-CHEMICAL-COMPOSITION',
                name: '',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: 'FD-SGP',
        name: 'SGP',
        route: '',
        expand: true,
        disabled: true,
        childs: [
          {
            id: 'FD-SGP-INPUT',
            name: 'Input',
            route: '/FD/SGP/Input/ProcessEngineer/Flaring',
            routeName: 'Input',
            disabled: true,
            expand: true,
            schilds: [
              {
                id: 'FD-SGP-INPUT-PROCESSENGINEER',
                name: 'Process Engineer',
                route: '',
                disabled: true,
                expand: true,
                tchilds: [
                  {
                    id: 'FD-SGP-INPUT-PROCESSENGINEER-FLARING',
                    name: 'Flaring',
                    route: '/FD/SGP/Input/ProcessEngineer/Flaring',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FD-SGP-INPUT-PROCESSENGINEER-MW',
                    name: 'MW',
                    route: '/FD/SGP/Input/ProcessEngineer/MW',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FD-SGP-INPUT-PROCESSENGINEER-LEAKAGE',
                    name: 'Leakage',
                    route: '/FD/SGP/Input/ProcessEngineer/Leakages',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FD-SGP-INPUT-PROCESSENGINEER-CONSTANTS',
                    name: 'Constants',
                    route: '/FD/SGP/Input/ProcessEngineer/Constants',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FD-SGP-INPUT-PROCESSENGINEER-PERMITS',
                    name: 'Permits',
                    route: '/FD/SGP/Input/ProcessEngineer/TargetPermit',
                    disabled: true,
                    expand: false,
                  },
                  {
                    id: 'FD-SGP-INPUT-PROCESSENGINEER-INPUT-HISTORY',
                    name: 'Input History',
                    route: '/FD/SGP/Input/ProcessEngineer/InputHistory',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FD-SGP-INPUT-PROCESSENGINEER-FLARE-SWITCHER',
                    name: 'Flare Switcher ',
                    route: '/FD/SGP/Input/ProcessEngineer/FlareSwitcher',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
              {
                id: 'FD-SGP-INPUT-OPERATOR',
                name: 'Operator',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: 'FD-SGP-INPUT-OPERATOR-FLARING',
                    name: 'Flaring ',
                    route: '/FD/SGP/Input/Operator/Flaring',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FD-SGP-DAILY-REPORT',
            name: 'Daily Report',
            route: '/FD/SGP/DailyReport',
            routeName: 'DailyReport',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: false,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FD-SGP-MONTHLY-REPORT',
            name: 'Monthly Report',
            route: '/FD/SGP/MonthlyReport',
            routeName: 'MonthlyReport',
            disabled: true,
            expand: false,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: false,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FD-SGP-CHEMICAL-COMPOSITION',
            name: 'Chemical Composition',
            route: '/FD/SGP/cc',
            routeName: 'cc',
            disabled: true,
            expand: false,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: false,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FD-SGP-SCHEMA',
            name: 'Schema',
            route: '/FD/SGP/Schema',
            routeName: 'Schema',
            disabled: true,
            expand: false,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: false,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: 'FD-SGI',
        name: 'SGI',
        route: '',
        disabled: true,
        expand: true,
        childs: [
          {
            id: 'FD-SGI-FLARE-REPORT',
            name: 'Flare Report',
            route: 'FD/SGI/flare-report',
            routeName: 'flare-report',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: 'FD-SGI-FLARE-REPORT',
                name: '',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FD-SGI-TARGET-PERMIT',
            name: 'Target Permit',
            route: 'FD/SGI/target-permit',
            routeName: 'target-permit',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: 'FD-SGI-TARGET-PERMIT',
                name: '',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FD-SGI-CC',
            name: 'Chemical Composition',
            route: 'FD/SGI/cc',
            routeName: 'cc',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: 'FD-SGI-CC',
                name: '',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: 'FD-FIELD',
        name: 'FIELD',
        route: '',
        expand: true,
        disabled: true,
        childs: [
          {
            id: 'FD-FIELD-INPUT',
            name: 'Input',
            route: 'FD/FIELD/Input',
            routeName: 'Input',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: 'FD-FIELD-INPUT-INPUTS',
                name: 'Input',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: 'FD-FIELD-INPUT-INPUTS-OPERATOR',
                    name: 'Operator',
                    route: 'FD/FIELD/Input/Operator',
                    disabled: true,
                    expand: false,
                  },
                  {
                    id: 'FD-FIELD-INPUT-INPUTS-PE',
                    name: 'PE',
                    route: 'FD/FIELD/Input/PE',
                    disabled: true,
                    expand: false,
                  },
                  {
                    id: 'FD-FIELD-INPUT-INPUTS-METRICS',
                    name: 'Metrics',
                    route: 'FD/FIELD/Input/Metrics',
                    disabled: true,
                    expand: false,
                  },
                  {
                    id: 'FD-FIELD-INPUT-INPUTS-PERMIT',
                    name: 'Permits',
                    route: 'FD/FIELD/Input/Permits',
                    disabled: true,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FD-FIELD-FIELDCALC',
            name: 'Field Calculation',
            route: 'FD/FIELD/FieldCalc',
            routeName: 'FieldCalc',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: 'FD-FIELD-FIELDCALC-FIELD-CALC',
                name: 'Field Calculation',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: 'FD-FIELD-FIELDCALC-FIELD-CALC-DRY-GAS',
                    name: 'Dry Gas',
                    route: 'FD/FIELD/FieldCalc/DryGas',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FD-FIELD-FIELD-CALC-RESERVOIR-GAS',
                    name: 'Reservoir Gas',
                    route: 'FD/FIELD/FieldCalc/ReservoirGas',
                    disabled: true,
                    expand: false,
                  },
                  {
                    id: 'FD-FIELD-FIELD-CALC-PURGE-N-PILOT',
                    name: 'Purge & Pilot',
                    route: 'FD/FIELD/FieldCalc/Purge&Pilot',
                    disabled: true,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FD-FIELD-FINAL-REPORT',
            name: 'Final Report',
            route: 'FD/FIELD/FinalReport',
            routeName: 'FinalReport',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: 'FD-FIELD-FINAL-REPORT-FINAL-REPORTs-GAS-BALANCE',
                name: 'Final Report',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: 'FD-FIELD-FINAL-REPORT-FINAL-REPORTs-GAS-BALANCE',
                    name: 'Gas Balance',
                    route: 'FD/FIELD/FinalReport/GasBalance',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FD-FIELD-FINAL-REPORT-FINAL-REPORTs-FLARING-REPORT',
                    name: 'Flaring Report',
                    route: 'FD/FIELD/FinalReport/FlaringReport',
                    disabled: true,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FD-FIELD-CC',
            name: 'Chemical Composition',
            route: 'FD/FIELD/ChemicalComposition',
            routeName: 'ChemicalComposition',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: 'FD-FIELD-CC-CCs',
                name: 'Chemical Composition',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: 'FD-FIELD-CC-CCs-FUEL-GAS',
                    name: 'Fuel Gas',
                    route: 'FD/FIELD/ChemicalComposition/FuelGas',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FD-FIELD-CC-RESERVOIR-GAS',
                    name: 'Reservoir Gas',
                    route: 'FD/FIELD/ChemicalComposition/ReservoirGas',
                    disabled: true,
                    expand: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: 'FD-LPG',
        name: 'LPG',
        route: '',
        expand: true,
        disabled: true,
        childs: [
          {
            id: 'FD-LPG-INPUT',
            name: 'Input',
            route: '/FD/LPG/Input/TargetPermit',
            routeName: 'Input',
            disabled: true,
            expand: true,
            schilds: [
              {
                id: 'FD-LPG-INPUT-TARGETPERMIT',
                name: 'Process Engineer',
                route: 'FD/LPG/Input/TargetPermit',
                disabled: false,
                expand: false,
                tchilds: [
                  {
                    id: 'FD-LPG-INPUT-PROCESS-ENGINEER-TARGETPERMIT',
                    name: 'Flaring',
                    route: '/FD/LPG/Input/PE/ProcessEngineer',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FD-LPG-INPUT-PROCESS-ENGINEER-TARGETPERMIT',
                    name: 'Permits',
                    route: 'FD/LPG/Input/TargetPermit',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
              {
                id: 'FD-LPG-INPUT-ANALYST',
                name: 'Analyst',
                route: '',
                disabled: false,
                expand: false,
                tchilds: [
                  {
                    id: 'FD-LPG-INPUT-ANALYST-FLARING',
                    name: 'RTC/Flaring',
                    route: 'FD/LPG/Input/Analyst',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
              {
                id: 'FD-LPG-INPUT-OPERATOR',
                name: 'Operator',
                route: 'FD/LPG/Input/Operator',
                disabled: false,
                expand: false,
                tchilds: [
                  {
                    id: 'FD-LPG-INPUT-OPERATOR-FLARING',
                    name: 'Flaring ',
                    route: '/FD/LPG/Input/Operator',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FD-LPG-FUEL-GAS-FLARING',
            name: 'Fuel Gas Flaring',
            route: 'FD/LPG/FuelGasFlaring',
            routeName: 'FuelGasFlaring',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FD-LPG-CC',
            name: 'Chemical Composition',
            route: 'FD/LPG/CC',
            routeName: 'CC',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FD-LPG-FINAL-REPORT',
            name: 'Final Report',
            route: '/FD/LPG/FinalReport/LPGData',
            routeName: 'FinalReport',
            disabled: true,
            expand: true,
            schilds: [
              {
                id: 'FD-LPG-FINAL-REPORT-FINAL-REPORTs-LPG-DATA',
                name: 'Final Reports',
                route: 'FD/LPG/FinalReport/LPGData',
                disabled: false,
                expand: false,
                tchilds: [
                  {
                    id: 'FD-LPG-FINAL-REPORT-FINAL-REPORTs-LPG-DATA',
                    name: 'LPG Data',
                    route: 'FD/LPG/FinalReport/LPGData',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FD-LPG-FINAL-REPORT-FINAL-REPORTs-FLARING-REPORT',
                    name: 'Flaring Report',
                    route: 'FD/LPG/FinalReport/FlaringReport',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: 'SO2-EMISSIONS',
        name: 'SO2 EMISSIONS',
        route: '',
        disabled: false,
        expand: true,
        childs: [
          {
            id: 'SO2-EMISSIONS-INPUT',
            name: 'Input',
            route: 'FD/KTLSGP/So2Emissions/ProjectedData',
            routeName: 'ProjectedData',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: 'SO2-EMISSIONS-INPUT-PROCESS-ENGINEER',
                name: 'Process Engineer',
                route: 'FD/KTLSGP/So2Emissions/ProjectedData',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: 'SO2EMISSIONS-KTLSGP-PROCESS-ENGINEER-PROJECTEDDATA',
                    name: 'Projected Data',
                    route: 'FD/KTLSGP/So2Emissions/ProjectedData',
                    disabled: true,
                    expand: false,
                  },
                  {
                    id: 'SO2EMISSIONS-KTLSGP-PROCESS-ENGINEER-KTL-PERMITS',
                    name: 'KTL Permits',
                    route: '/FD/KTL/Input/ProcessEngineer/TargetPermit',
                    disabled: true,
                    expand: false,
                  },
                  {
                    id: 'SO2EMISSIONS-KTLSGP-PROCESS-ENGINEER-SGP-PERMITS',
                    name: 'SGP Permits',
                    route: '/FD/SGP/Input/ProcessEngineer/TargetPermit',
                    disabled: true,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'SO2EMISSIONS-KTLSGP-PROJECTEDDATA',
            name: 'Monthly Report',
            route: 'FD/KTLSGP/So2Emissions/MonthlyReport',
            routeName: 'MonthlyReport',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: 'SO2EMISSIONS-KTLSGP-PROJECTEDDATA',
                name: '',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: 'FD-3GP',
        name: '3GP',
        route: '',
        expand: true,
        disabled: true,
        childs: [
          {
            id: 'FD-3GP-INPUT',
            name: 'Input',
            route: '/FD/3GP/Input',
            routeName: 'Input',
            disabled: true,
            expand: true,
            schilds: [
              {
                id: 'FD-3GP-INPUT-PROCESSENGINEER',
                name: 'Process Engineer',
                route: '',
                disabled: true,
                expand: true,
                tchilds: [
                  {
                    id: 'FD-3GP-INPUT-PROCESSENGINEER-MANUAL-FLARING',
                    name: 'Flaring    ',
                    route: '/FD/3GP/Input/ProcessEngineer/ManualFlaring',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FD-3GP-INPUT-PROCESSENGINEER-LEAKAGE',
                    name: 'Leakage',
                    route: '/FD/3GP/Input/ProcessEngineer/Leakage',
                    disabled: true,
                    expand: false,
                  },
                  {
                    id: 'FD-3GP-INPUT-PROCESSENGINEER-CONSTANTS',
                    name: 'Constants',
                    route: '/FD/3GP/Input/ProcessEngineer/Constants',
                    disabled: true,
                    expand: false,
                  },
                  {
                    id: 'FD-3GP-INPUT-PROCESSENGINEER-PERMITS',
                    name: 'Permits',
                    route: '/FD/3GP/Input/ProcessEngineer/Permits',
                    disabled: true,
                    expand: false,
                  },
                  {
                    id: 'FD-3GP-INPUT-PROCESSENGINEER-INPUT-HISTORY',
                    name: 'Input History',
                    route: '/FD/3GP/Input/ProcessEngineer/InputHistory',
                    disabled: true,
                    expand: false,
                  },
                  {
                    id: 'FD-3GP-INPUT-PROCESSENGINEER-FLARE-SWITCHER',
                    name: 'Flare Switcher',
                    route: '/FD/3GP/Input/ProcessEngineer/FlareSwitcher',
                    disabled: true,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FD-3GP-DAILY-REPORT',
            name: 'Daily Report',
            route: '/FD/3GP/DailyReport',
            routeName: 'DailyReport',
            disabled: true,
            expand: true,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: true,
                expand: true,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FD-3GP-MONTHLY-REPORT',
            name: 'Monthly Report',
            route: '/FD/3GP/MonthlyReport',
            routeName: 'MonthlyReport',
            disabled: true,
            expand: true,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: true,
                expand: true,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FD-3GP-CHEMICAL-COMPOSITION',
            name: 'Chemical Composition',
            route: '/FD/3GP/CC',
            routeName: 'CC',
            disabled: true,
            expand: true,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: true,
                expand: true,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
              {
                id: 'FD-3GP-INPUT-OPERATOR',
                name: 'Operator',
                route: '',
                disabled: false,
                expand: true,
                tchilds: [
                  {
                    id: 'FD-3GP-INPUT-OPERATOR-FLARING',
                    name: 'Flaring ',
                    route: '/FD/3GP/Input/Operator',
                    disabled: true,
                    expand: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: 'FD-3GI',
        name: '3GI',
        route: '',
        expand: true,
        disabled: true,
        childs: [
          {
            id: 'FD-3GI-INPUT',
            name: 'Input',
            route: '/FD/3GI/Input',
            routeName: 'Input',
            disabled: true,
            expand: true,
            schilds: [
              {
                id: 'FD-3GI-INPUT-PROCESSENGINEER',
                name: 'Process Engineer',
                route: '',
                disabled: true,
                expand: true,
                tchilds: [
                  {
                    id: 'FD-3GI-INPUT-PROCESSENGINEER-MANUAL-FLARING',
                    name: 'Flaring    ',
                    route: '/FD/3GI/Input/ProcessEngineer/ManualFlaring',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FD-3GI-INPUT-PROCESSENGINEER-LEAKAGE',
                    name: 'Leakage',
                    route: '/FD/3GI/Input/ProcessEngineer/Leakage',
                    disabled: true,
                    expand: false,
                  },
                  {
                    id: 'FD-3GI-INPUT-PROCESSENGINEER-CONSTANTS',
                    name: 'Constants',
                    route: '/FD/3GI/Input/ProcessEngineer/Constants',
                    disabled: true,
                    expand: false,
                  },
                  {
                    id: 'FD-3GI-INPUT-PROCESSENGINEER-PERMITS',
                    name: 'Permits',
                    route: '/FD/3GI/Input/ProcessEngineer/Permits',
                    disabled: true,
                    expand: false,
                  },
                  {
                    id: 'FD-3GI-INPUT-PROCESSENGINEER-INPUT-HISTORY',
                    name: 'Input History',
                    route: '/FD/3GI/Input/ProcessEngineer/InputHistory',
                    disabled: true,
                    expand: false,
                  },
                  // {
                  //   id: 'FD-3GP-INPUT-PROCESSENGINEER-FLARE-SWITCHER',
                  //   name: 'Flare Switcher',
                  //   route: '/FD/3GP/Input/ProcessEngineer/FlareSwitcher',
                  //   disabled: true,
                  //   expand: false,
                  // },
                ],
              },
            ],
          },
          {
            id: 'FD-3GI-DAILY-REPORT',
            name: 'Daily Report',
            route: '/FD/3GI/DailyReport',
            routeName: 'DailyReport',
            disabled: true,
            expand: true,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: true,
                expand: true,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FD-3GI-MONTHLY-REPORT',
            name: 'Monthly Report',
            route: '/FD/3GI/MonthlyReport',
            routeName: 'MonthlyReport',
            disabled: true,
            expand: true,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: true,
                expand: true,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FD-3GI-CHEMICAL-COMPOSITION',
            name: 'Chemical Composition',
            route: '/FD/3GI/CC',
            routeName: 'CC',
            disabled: true,
            expand: true,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: true,
                expand: true,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              }
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'FGD',
    name: 'FGD',
    route: '',
    routeName: 'FGD',
    items: [
      {
        id: 'FGD-KTL',
        name: 'KTL',
        route: '',
        expand: true,
        disabled: true,
        childs: [
          {
            id: 'FGD-KTL-PRODUCTION-GAS-BALANCE',
            name: 'Daily Report',
            route: 'FGD/KTL/ProductionGasBalance',
            routeName: 'ProductionGasBalance',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FGD-KTL-MONTHLY-REPORT',
            name: 'Monthly Report',
            route: 'FGD/KTL/monthly-report',
            routeName: 'monthly-report',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: 'FGD-SGP',
        name: 'SGP',
        route: '',
        disabled: true,
        expand: true,
        childs: [
          {
            id: 'FGD-SGP-DAILY-REPORT',
            name: 'Daily Report',
            route: 'FGD/SGP/DailyReport',
            routeName: 'DailyReport',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FGD-SGP-MONTHLY-REPORT',
            name: 'Monthly Report',
            route: 'FGD/SGP/MonthlyReport',
            routeName: 'MonthlyReport',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FGD-SGP-GAS-USAGE-REPORT',
            name: 'Gas Usage Report',
            route: 'FGD/SGP/GasUsageReport',
            routeName: 'GasUsageReport',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: 'FGD-SGP-GAS-USAGE-REPORT',
                name: '',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: 'FGD-FIELD',
        name: 'FIELD',
        route: '',
        expand: true,
        disabled: true,
        childs: [
          {
            id: 'FGD-FIELD-INPUT',
            name: 'Input',
            route: 'FD/FIELD/Input',
            routeName: 'Input',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: 'FGD-FIELD-INPUT-INPUTS',
                name: 'Input',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: 'FGD-FIELD-INPUT-INPUTS-OPERATOR',
                    name: 'Operator',
                    route: 'FD/FIELD/Input/Operator',
                    disabled: true,
                    expand: false,
                  },
                  {
                    id: 'FGD-FIELD-INPUT-INPUTS-PE',
                    name: 'PE',
                    route: 'FD/FIELD/Input/PE',
                    disabled: true,
                    expand: false,
                  },
                  {
                    id: 'FGD-FIELD-INPUT-INPUTS-METRICS',
                    name: 'Metrics',
                    route: 'FD/FIELD/Input/Metrics',
                    disabled: true,
                    expand: false,
                  },
                  {
                    id: 'FGD-FIELD-INPUT-INPUTS-PERMIT',
                    name: 'Permits',
                    route: 'FD/FIELD/Input/Permits',
                    disabled: true,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FGD-FIELD-FIELDCALC',
            name: 'Field Calculation',
            route: 'FD/FIELD/FieldCalc',
            routeName: 'FieldCalc',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: 'FGD-FIELD-FIELDCALC-FIELD-CALC',
                name: 'Field Calculation',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: 'FGD-FIELD-FIELDCALC-FIELD-CALC-DRY-GAS',
                    name: 'Dry Gas',
                    route: 'FD/FIELD/FieldCalc/DryGas',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FGD-FIELD-FIELD-CALC-RESERVOIR-GAS',
                    name: 'Reservoir Gas',
                    route: 'FD/FIELD/FieldCalc/ReservoirGas',
                    disabled: true,
                    expand: false,
                  },
                  {
                    id: 'FGD-FIELD-FIELD-CALC-PURGE-N-PILOT',
                    name: 'Purge & Pilot',
                    route: 'FD/FIELD/FieldCalc/Purge&Pilot',
                    disabled: true,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FGD-FIELD-FINAL-REPORT',
            name: 'Final Report',
            route: 'FD/FIELD/FinalReport',
            routeName: 'FinalReport',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: 'FGD-FIELD-FINAL-REPORT-FINAL-REPORTs-GAS-BALANCE',
                name: 'Final Report',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: 'FGD-FIELD-FINAL-REPORT-FINAL-REPORTs-GAS-BALANCE',
                    name: 'Gas Balance',
                    route: 'FD/FIELD/FinalReport/GasBalance',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FGD-FIELD-FINAL-REPORT-FINAL-REPORTs-FLARING-REPORT',
                    name: 'Flaring Report',
                    route: 'FD/FIELD/FinalReport/FlaringReport',
                    disabled: true,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FGD-FIELD-CC',
            name: 'Chemical Composition',
            route: 'FD/FIELD/ChemicalComposition',
            routeName: 'ChemicalComposition',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: 'FGD-FIELD-CC-CCs',
                name: 'Chemical Composition',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: 'FGD-FIELD-CC-CCs-FUEL-GAS',
                    name: 'Fuel Gas',
                    route: 'FD/FIELD/ChemicalComposition/FuelGas',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FGD-FIELD-CC-RESERVOIR-GAS',
                    name: 'Reservoir Gas',
                    route: 'FD/FIELD/ChemicalComposition/ReservoirGas',
                    disabled: true,
                    expand: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: 'FGD-LPG',
        name: 'LPG',
        route: '',
        expand: true,
        disabled: true,
        childs: [
          {
            id: 'FGD-LPG-INPUT',
            name: 'Input',
            route: '/FD/LPG/Input/TargetPermit',
            routeName: 'Input',
            disabled: true,
            expand: true,
            schilds: [
              {
                id: 'FGD-LPG-INPUT-TARGETPERMIT',
                name: 'Process Engineer',
                route: 'FD/LPG/Input/TargetPermit',
                disabled: false,
                expand: false,
                tchilds: [
                  {
                    id: 'FGD-LPG-INPUT-PROCESS-ENGINEER-TARGETPERMIT',
                    name: 'Flaring',
                    route: '/FD/LPG/Input/PE/ProcessEngineer',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FGD-LPG-INPUT-PROCESS-ENGINEER-TARGETPERMIT',
                    name: 'Permits',
                    route: 'FD/LPG/Input/TargetPermit',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
              {
                id: 'FGD-LPG-INPUT-ANALYST',
                name: 'Analyst',
                route: '',
                disabled: false,
                expand: false,
                tchilds: [
                  {
                    id: 'FGD-LPG-INPUT-ANALYST-FLARING',
                    name: 'RTC/Flaring',
                    route: 'FD/LPG/Input/Analyst',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
              {
                id: 'FGD-LPG-INPUT-OPERATOR',
                name: 'Operator',
                route: 'FD/LPG/Input/Operator',
                disabled: false,
                expand: false,
                tchilds: [
                  {
                    id: 'FGD-LPG-INPUT-OPERATOR-FLARING',
                    name: 'Flaring ',
                    route: '/FD/LPG/Input/Operator',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FGD-LPG-FUEL-GAS-FLARING',
            name: 'Fuel Gas Flaring',
            route: 'FD/LPG/FuelGasFlaring',
            routeName: 'FuelGasFlaring',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FGD-LPG-CC',
            name: 'Chemical Composition',
            route: 'FD/LPG/CC',
            routeName: 'CC',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FGD-LPG-FINAL-REPORT',
            name: 'Final Report',
            route: '/FD/LPG/FinalReport/LPGData',
            routeName: 'FinalReport',
            disabled: true,
            expand: true,
            schilds: [
              {
                id: 'FGD-LPG-FINAL-REPORT-FINAL-REPORTs-LPG-DATA',
                name: 'Final Reports',
                route: 'FD/LPG/FinalReport/LPGData',
                disabled: false,
                expand: false,
                tchilds: [
                  {
                    id: 'FGD-LPG-FINAL-REPORT-FINAL-REPORTs-LPG-DATA',
                    name: 'LPG Data',
                    route: 'FD/LPG/FinalReport/LPGData',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FGD-LPG-FINAL-REPORT-FINAL-REPORTs-FLARING-REPORT',
                    name: 'Flaring Report',
                    route: 'FD/LPG/FinalReport/FlaringReport',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: 'FGD-SGI',
        name: 'SGI',
        route: '',
        disabled: true,
        expand: true,
        childs: [
          {
            id: 'FGD-SGI-FLARE-REPORT',
            name: 'Flare Report',
            route: 'FD/SGI/flare-report',
            routeName: 'flare-report',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FGD-SGI-TARGET-PERMIT',
            name: 'Target Permit',
            route: 'FD/SGI/target-permit',
            routeName: 'target-permit',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FGD-SGI-CC',
            name: 'Chemical Composition',
            route: 'FD/SGI/cc',
            routeName: 'cc',
            disabled: false,
            expand: false,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: true,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: 'FGD-IUS',
        name: 'Internal Usage',
        route: '',
        disabled: true,
        expand: true,
        childs: [
          {
            id: 'FGD-IUS-INPUT',
            name: 'Input',
            route: 'FGD/IUS/Input/boilers-motohours-data',
            routeName: 'Input',
            disabled: true,
            expand: true,
            schilds: [
              {
                id: 'FGD-IUS-INPUT-PROCESS-ENGINEER',
                name: 'Process Engineer',
                route: '',
                disabled: false,
                expand: false,
                tchilds: [
                  {
                    id: 'FGD-IUS-INPUT-PROCESS-ENGINEER-BOILERHOUSEDATA',
                    name: 'Boilers Motohours Data',
                    route: 'FGD/IUS/Input/boilers-motohours-data',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FGD-IUS-INPUT-PROCESS-ENGINEER-HEATERSDATA',
                    name: 'Heaters Motohours Data',
                    route: 'FGD/IUS/Input/heaters-motohours-data',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FGD-IUS-INPUT-PROCESS-ENGINEER-METERSDATA',
                    name: 'Meters Data',
                    route: 'FGD/IUS/Input/meters-data',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FGD-IUS-CALCULATIONS',
            name: 'Calculations',
            route: 'FGD/IUS/calculations/boilers-motohours-data',
            routeName: 'calculations',
            disabled: true,
            expand: true,
            schilds: [
              {
                id: 'FGD-IUS-CALCULATIONS-CALCULATIONS',
                name: 'Calculations',
                route: '',
                disabled: false,
                expand: false,
                tchilds: [
                  {
                    id: 'FGD-IUS-CALCULATIONS-CALCULATIONS-FGU-BOILER',
                    name: 'Boilers Motohours Data',
                    route: 'FGD/IUS/calculations/boilers-motohours-data',
                    disabled: false,
                    expand: false,
                  },
                  {
                    id: 'FGD-IUS-CALCULATIONS-CALCULATIONS-FGU-HEATER',
                    name: 'Heaters Motohours Data',
                    route: 'FGD/IUS/calculations/heaters-motohours-data',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FGD-IUS-MONTHLY-REPORT',
            name: 'Monthly Report',
            route: 'FGD/IUS/MonthlyReport/monthly-calc',
            routeName: 'monthly-calc',
            disabled: true,
            expand: true,
            schilds: [
              {
                id: 'FGD-IUS-MONTHLY-REPORT-MONTHLY-REPORT',
                name: 'Monthly Report',
                route: '',
                disabled: false,
                expand: false,
                tchilds: [
                  {
                    id: 'FGD-IUS-MONTHLY-REPORT-MONTHLY-REPORT-MONTHLY-CALC',
                    name: 'Monthly Calc',
                    route: 'FGD/IUS/MonthlyReport/monthly-calc',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: 'FGD-3GP',
        name: '3GP',
        route: '',
        disabled: true,
        expand: true,
        childs: [
          {
            id: 'FGD-3GP-GUR',
            name: 'Gas Usage Report',
            route: 'FGD/3GP/GUR',
            routeName: 'GUR',
            disabled: true,
            expand: true,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: false,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
          {
            id: 'FGD-3GP-CHEMICAL-COMPOSITION',
            name: 'Chemical Composition',
            route: 'FGD/3GP/CC',
            routeName: 'CC',
            disabled: true,
            expand: true,
            schilds: [
              {
                id: '',
                name: '',
                route: '',
                disabled: false,
                expand: false,
                tchilds: [
                  {
                    id: '',
                    name: '',
                    route: '',
                    disabled: false,
                    expand: false,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  //{
  //  id: 'DATA-RECOVERY',
  //  name: 'DATA RECOVERY',
  //  route: '',
  //  routeName: 'DataRecovery',
  //  items: [
  //    {
  //      id: 'DATA-RECOVERY-KTL',
  //      name: 'KTL',
  //      route: '',
  //      expand: true,
  //      disabled: true,
  //      childs: [
  //        {
  //          id: 'DATA-RECOVERY-KTL-MONTHLY-REPORT',
  //          name: 'Monthly Report',
  //          route: '/DataRecovery/KTL/monthly-report',
  //          routeName: 'monthly-report',
  //          disabled: false,
  //          expand: false,
  //          schilds: [
  //            {
  //              id: '',
  //              name: '',
  //              route: '',
  //              disabled: true,
  //              expand: false,
  //              tchilds: [
  //                {
  //                  id: '',
  //                  name: '',
  //                  route: '',
  //                  disabled: false,
  //                  expand: false,
  //                },
  //              ],
  //            },
  //          ],
  //        },
  //        {
  //          id: 'DATA-RECOVERY-KTL-DAILY-REPORT',
  //          name: 'Daily Report',
  //          route: 'DataRecovery/KTL/daily-report',
  //          routeName: 'daily-report',
  //          disabled: false,
  //          expand: false,
  //          schilds: [
  //            {
  //              id: '',
  //              name: '',
  //              route: '',
  //              disabled: true,
  //              expand: false,
  //              tchilds: [
  //                {
  //                  id: '',
  //                  name: '',
  //                  route: '',
  //                  disabled: false,
  //                  expand: false,
  //                },
  //              ],
  //            },
  //          ],
  //        },
  //      ],
  //    },
  //  ],
  //},
];
